export const NOTIFICATION_TYPE = [
    {
        name: 'geofence',
        actions: [
            {
                name: 'enter',
                value: 1
            },
            {
                name: 'exit',
                value: 0
            }
        ]
    }
]
